<script>
    import "./projectPreviewTab.css"
    import {signerAddress} from "svelte-ethers-store";
    export let currentStep, setCurrentStep, saleContract

</script>
<div class="project-tabs">
    <ul class="list-none flex items-center scroller project-tabs relative">
        <li class={currentStep === 1 ? "active" : ""} on:click={ () => setCurrentStep(1)}><a>About</a></li>
        <li class={currentStep === 2 ? "active" : ""} on:click={ () => setCurrentStep(2)}><a>Raise Details</a></li>
        {#if $signerAddress && saleContract}
            <li class={currentStep === 3 ? "active" : ""} on:click={ () => setCurrentStep(3)}><a>My Transactions</a></li>
        {/if}
    </ul>
</div>
